export default __webpack_public_path__ + "static/media/image-homepage-profile.27a4a72c.jpg";